module.exports = __webpack_public_path__ + "img/mat_411.c5ab715b.png";